// 入会管理-代办

import server from '../services/todo'
import { message } from 'antd'
const { getAllToDoList, getMyToDoList } = server

const namespace = 'todo'

export default {
  namespace,
  state: {
    allTodoList: [],
    myTodoList: [],
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 获取全部代办
    *getAllToDoList({ payload, callback }, { call, put }) {
      const res = yield call(getAllToDoList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { allTodoList: res.data },
        })
        !!callback && callback(res)
      }
    },

    // 获取我的代办
    *getMyToDoList({ payload, callback }, { call, put }) {
      const res = yield call(getMyToDoList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { myTodoList: res.data },
        })
        !!callback && callback(res)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
